module.exports = __webpack_public_path__ + "static/media/otherservices2.be44bec2.jpg";